// extracted by mini-css-extract-plugin
module.exports = {"faq-container":"_82e3db2ea0--faq-container--TbgzN","faq-html-insert":"_82e3db2ea0--faq-html-insert--cuxsI"};